import { render, staticRenderFns } from "./CompanyTom.vue?vue&type=template&id=cab6bf94&"
import script from "./CompanyTom.vue?vue&type=script&lang=js&"
export * from "./CompanyTom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports